//Element selectors
//Tier 0: below 30
//Tier 1: 30-50
//Tier 2: over 50

const popup_button = document.querySelectorAll('.gwp-popup-button');
const popup = document.querySelector('.gwp-popup-container');
const popup_close_button = document.querySelector('.gwp-popup-container .popup--close-btn');
const wethemeGlobal = document.querySelector('script#wetheme-global');
const translationsObject = window.translations;
const cartDrawer = document.querySelector(".cart-drawer");
const cartCountIndicators = document.querySelectorAll("[data-cart-count-indicator]");

function openCartDrawer() {
    cartDrawer.classList.add("cart-drawer--active");
    document.body.classList.add('js-drawer-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove("cart-drawer--active");
    document.body.classList.remove('js-drawer-open');
}

function updateCartItemCounts(count) {
    document.querySelectorAll("[data-cart-count-indicator]").forEach((el) => {
        el.textContent = count;
    });
}


//TODO - not render complementary products in cart drawer
async function updateCartDrawer() {
    const res = await fetch(window.Shopify.routes.root + "?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;
    
    addCartDrawerListeners();
}

function handleQuantityChangeListener() {
    cartDrawer
        .querySelectorAll(".cart-drawer-quantity-selector button")
        .forEach((button) => {
            button.addEventListener("click", async () => {
                // Get line item key
                const rootItem = button.closest("[data-line-item-key]");
                const key = rootItem.getAttribute("data-line-item-key");
                const productTitle = rootItem.getAttribute("data-item-title");
                const input = button.parentElement.querySelector("input");

                // Get new quantity
                const currentQuantity = Number(input.value);
                const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
                const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

                await handleItemQuantityChange(key, newQuantity, productTitle);
            });
        });
}

function handleRemoveItemsListener() {
    // Remove item
    cartDrawer.querySelectorAll(".remove-item").forEach((button) => {
        button.addEventListener("click", async (event) => {
            const button = event.target.closest(".remove-item");
            if (!button) return;

            // Get line item key
            const rootItem = button.closest("[data-line-item-key]");
            const key = rootItem.getAttribute("data-line-item-key");

            await handleItemQuantityChange(key, 0);
            if (rootItem.classList.contains("gwp-cart-item")) {
                handleFreeSampleRemoval(key);
            }
        });
    });
}

function handleQuantityInputChangeListener() {
    cartDrawer.querySelectorAll('.cart-item-quantity').forEach((el) => {
        el.addEventListener('change', async (e) => {
        const product = e.target.closest('.cart-drawer-item');
        const key = product.getAttribute('data-line-item-key');
        const productTitle = product.getAttribute('data-item-title');
        const newQuantity = e.target.value;
        await handleItemQuantityChange(key, newQuantity, productTitle);
        });
    });
}

function handleComplementaryProductsAddToCart() {
    cartDrawer.querySelectorAll('.complementary_products_add_to_cart').forEach(item => {
        item.addEventListener('click', async function (e) {
            e.preventDefault();
            const product_id = item.dataset.productId;
                await handleItemAddition([product_id]);
        });
    });
}

function handleCartOpenAndCloseListeners() {
    const closeButtons = document.querySelectorAll(".cart-drawer-header-right-close");
    const cart_drawer_box = document.querySelector(".cart-drawer-box");
    if (cart_drawer_box) {
        document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }

    //close cart drawer on outside click
    document.addEventListener("mousedown", (e) => {
        if (!e.target.closest('.cart-drawer-box') && !e.target.closest('.cart-icon') && !e.target.closest('#modal_gwp')) {
            closeCartDrawer();
        }
    });

    closeButtons.forEach((el) => {
        el.addEventListener("click", () => {
            closeCartDrawer();
        });
    });
}


function addCartDrawerListeners() {
    // Update quantities
    handleQuantityChangeListener();
    handleQuantityInputChangeListener();
    handleRemoveItemsListener();
    handleComplementaryProductsAddToCart();
    handleCartOpenAndCloseListeners();

    // Popup button in cart drawer
    if (document.querySelector('.gwp-popup-button')) {
        document.querySelector('.gwp-popup-button').addEventListener('click', openPopup);
    }

}

async function getCart() {
    // get the cart value with .cart
    const cart = await fetch('/cart.js');
    const cartJson = await cart.json();
    return cartJson;
}

function handleFreeSampleRemoval(key) {
        let removed_id = key.split(':')[0];
        GWP.already_in_cart_count--;
        const popup_product = popup.querySelector(`.gwp-product[data-product-id="${removed_id}"]`);
        popup_product.classList.remove('gwp-selected');
        popup_product.querySelector('.gwp-add-to-cart').textContent = translationsObject.gwp_add_to_cart;
}

function calculateCurrentTier(cartValue) {
    const gift_cards = cartValue.items.filter(item => item.gift_card
        == true);
    const gift_cards_total = gift_cards.reduce((acc, item) => acc + item.final_price, 0);
    let tier = 0;
    let total = cartValue.total_price - gift_cards_total;
    if (total >= GWP.tier_2_threshold) {
        tier = 2;
    } else if (total >= GWP.tier_1_threshold) {
        tier = 1;
    }
    return tier;
}

function openPopup(e) {
    e.preventDefault();
    popup.showModal();
}

function closePopup(e) {
    e.preventDefault();
    popup.close();
}  

//if the page is not cart page, open the cart drawer when the cart icon is clicked

if(window.location.pathname != '/cart'){
    document.querySelectorAll('a[href="/cart"], a[href="/it/cart').forEach((a) => {
        a.addEventListener("click", (e) => {
            e.preventDefault();
            openCartDrawer();
        });
    });
}

if (popup_button) {
    popup_button.forEach(el => el.addEventListener('click', openPopup));
}

if (popup_close_button) {
    popup_close_button.addEventListener('click', closePopup);
}

popup.addEventListener('click', function (e) {
    if (e.target.id == 'prompt__background') {
        popup.close();
    }
});

async function initPopup(cart) {
    //get the tier and the GWP items in the cart
    const tier = calculateCurrentTier(cart);
    const GWP_items_in_cart = cart.items.filter(item => GWP.target_products.some(target => target.id == item.variant_id));

    if (tier == 0) {
        if (GWP_items_in_cart.length > 0) {
            const items_to_remove = GWP_items_in_cart.map(item => item.id);
            await handleSampleRemoval(items_to_remove);
            updateCartDrawer();
        }
    }
    if(tier == 1) {
        if(GWP_items_in_cart.length == 1){
            const selected_sample = popup.querySelector(`.gwp-product[data-product-id="${GWP_items_in_cart[0].id}"]`);
            selected_sample.querySelector('.gwp-add-to-cart').textContent = translationsObject.gwp_remove_from_cart;
            selected_sample.classList.add('gwp-selected');
            selected_sample.querySelector('.gwp-add-to-cart').disabled = false;

            const other_samples = popup.querySelectorAll('.gwp-product:not(.gwp-selected)');
            other_samples.forEach(item => {
                item.querySelector('.gwp-add-to-cart').disabled = true;
            });
        }
        else if(GWP_items_in_cart.length == 2){
            const items_to_remove = GWP_items_in_cart.map(item => item.id);
            await handleSampleRemoval(items_to_remove);
            popup.querySelectorAll('.gwp-product').forEach(item => {
                item.classList.remove('gwp-selected');
                item.querySelector('.gwp-add-to-cart').textContent = translationsObject.translations.gwp_add_to_cart;
                item.querySelector('.gwp-add-to-cart').disabled = false;
            });
        }
        else if(GWP_items_in_cart.length == 0){
            document.querySelectorAll('.gwp-add-to-cart').disabled = false;
        }
    }
    if(tier == 2) {
        document.querySelector('.gwp-add-to-cart').disabled = false;
        if(GWP_items_in_cart.length > 0){
            const selected_sample = popup.querySelector(`.gwp-product[data-product-id="${GWP_items_in_cart[0].id}"]`);
            selected_sample.querySelector('.gwp-add-to-cart').textContent = translationsObject.gwp_remove_from_cart;
            selected_sample.classList.add('gwp-selected');
            selected_sample.querySelector('.gwp-add-to-cart').disabled = false;
        }
    }
}

function initCart() {
    addCartDrawerListeners();
    if(popup){
        getCart().then(cart => {
            initPopup(cart);
        });
    }
}

async function handleItemQuantityChange(key, newQuantity, productTitle) {
    try {
        const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: key,
                quantity: newQuantity,
            }),
        });

        if (!res.ok) {
            const error = await res.json();
            document.getElementById('cart_error_message').textContent = `${productTitle} ${translationsObject.increase_quantity_error}`;
            throw new Error(`Network response was not ok: ${res.statusText}`);
        }

        const cart = await res.json();

        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
        handleGWPCalculation(cart);

    } catch (error) {
        console.error("Error updating cart:", error);
    }
}

async function handleSampleRemoval(variant_ids) {
    const updates = variant_ids.reduce((acc, variant_id) => {
        acc[variant_id] = 0;
        return acc;
    }, {});

    const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
    });
    const cart = await res.json();

    updateCartItemCounts(cart.item_count);
    if(window.location.pathname.indexOf('/cart') > -1){
        location.reload();
    } else {
        updateCartDrawer();
    }
    handleGWPCalculation(cart);
}

async function handleItemAddition(items) {
    const formData = {
        items: items.map(item => ({
            id: item,
            quantity: 1,
        })),
    };

    try {
        // Ajax update
        const res = await fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        });

        if (!res.ok) {
            throw new Error(`Network response was not ok: ${res.statusText}`);
        }

        const cart = await getCart();

        updateCartItemCounts(cart.item_count);
        if(window.location.pathname.indexOf('/cart') > -1){
            location.reload();
        } else {
            updateCartDrawer();
        }
        updateCartDrawer();
        handleGWPCalculation(cart);

    } catch (error) {
        console.error("Error updating cart:", error);
    }
}

document.querySelectorAll('.complementary_products_add_to_cart').forEach(item => {
    item.addEventListener('click', async function (e) {
        e.preventDefault();
        const product_id = item.dataset.productId;
            await handleItemAddition([product_id]);
    });
});

//Add GWP product to the cart
popup.querySelectorAll('.gwp-add-to-cart').forEach(item => {
    item.addEventListener('click', async function () {
        // disable other .gwp-add-to-cart buttons while the handleItemAddition is in progress
        popup.querySelectorAll('.gwp-add-to-cart').forEach(button => {
            button.disabled = true;
        });
        //Get needed params
        let $block = item.closest('.gwp-product');
        const product_id = $block.dataset.productId;
        const cart = await getCart();
        const cartItems = cart.items;
        const productInCart = cartItems.find(item => item.variant_id == product_id);

        if($block.classList.contains('gwp-selected')){
            //Delete item
            GWP.already_in_cart_count--;

            let updates = {};
            updates[$block.dataset.id] = 0;
            handleSampleRemoval([product_id]);
            item.textContent = translationsObject.gwp_add_to_cart;
            $block.classList.remove('gwp-selected');
            popup.close();
        } 
        else {
            //Add item
            if(!productInCart){
                GWP.already_in_cart_count++;
                await handleItemAddition([product_id]);
                popup.querySelectorAll('.gwp-add-to-cart').forEach(button => {
                    button.disabled = false;
                });
                item.textContent = translationsObject.gwp_remove_from_cart;
                $block.classList.add('gwp-selected');
                popup.close();
            }
        }
    })
})


async function handleGWPCalculation() {
    const cart = await getCart();
    const tier = calculateCurrentTier(cart);
    const GWP_items_in_cart = cart.items.filter(item => GWP.target_products.some(target => target.id == item.variant_id));
    if (tier == 0) {
        if (GWP_items_in_cart.length > 0) {
            const items_to_remove = GWP_items_in_cart.map(item => item.id);
            await handleSampleRemoval(items_to_remove);
            updateCartDrawer();
        }
    }
    if(tier == 1) {
        if(GWP_items_in_cart.length == 1){
            const other_samples = popup.querySelectorAll('.gwp-product:not(.gwp-selected)');
            other_samples.forEach(item => {
                item.querySelector('.gwp-add-to-cart').disabled = true;
            });
        }
        else if(GWP_items_in_cart.length == 2){
            const items_to_remove = GWP_items_in_cart.map(item => item.id);
            await handleSampleRemoval(items_to_remove);
            popup.querySelectorAll('.gwp-product').forEach(item => {
                const add_to_cart_button = item.querySelector('.gwp-add-to-cart');
                item.classList.remove('gwp-selected');
                add_to_cart_button.textContent = translationsObject.translations.gwp_add_to_cart;
                add_to_cart_button.disabled = false;
            });
        }
        else if(GWP_items_in_cart.length == 0){
            document.querySelectorAll('.gwp-selected').forEach(gwp_product => {
                gwp_product.classList.remove('gwp-selected');
            });
            document.querySelectorAll('.gwp-add-to-cart').forEach(button => {
                button.disabled = false;
                button.textContent = translationsObject.gwp_add_to_cart;
            });
        }
    }
    if(tier == 2) {
        document.querySelectorAll('.gwp-add-to-cart').forEach(button => {
            button.disabled = false;
        });
    }
}

initCart();

document.addEventListener('cart:updated', async function(e){
    setTimeout(() => {
        addCartDrawerListeners();
    }, 1000);
    await handleGWPCalculation();
});

 